// extracted by mini-css-extract-plugin
export default {"wrapper":"Table_wrapper__MkyTs","row":"Table_row__-V7KV","col":"Table_col__3vBu9","foot":"Table_foot__6QCM8","button":"Table_button__RN0Kt","loader":"Table_loader__ZreNz"};